import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { swapDeepProperty, swapProperty } from "../support/object";
import { HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID } from "src/app/core/http-context-tokens";

@Injectable()
export class MongoIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let clonedRequest: HttpRequest<any> | null = null;

    if (
      req.context.get(HTTP_CONTEXT_TOKEN_NO_SWAP_DEEP_PROPERTY_ID) ||
      req.url.indexOf("/calendar/appointments") >= 0 ||
      req.url.indexOf("/directory/patients") >= 0 ||
      req.url.indexOf("/healthcare/master-cases") >= 0 ||
      req.url.indexOf("/healthcare/templates") >= 0 ||
      req.url.indexOf("/healthcare/tickets") >= 0 ||
      req.url.indexOf("/calendar/templates") >= 0 ||
      req.url.indexOf("/healthcare/health-records") >= 0 ||
      req.url.indexOf("/billing/invoices") >= 0 ||
      req.url.indexOf("/billing/carts") >= 0 ||
      req.url.indexOf("/billing/books") >= 0 ||
      req.url.indexOf("/billing/quotes") >= 0 ||
      req.url.indexOf("/billing/fiscal-profiles") >= 0 ||
      req.url.indexOf("/healthcare/tasks") >= 0 ||
      req.url.indexOf("/diagnostic/requests") >= 0 ||
      req.url.indexOf("/healthcare/work-orders") >= 0 ||
      req.url.indexOf("/healthcare/prescriptions") >= 0 ||
      req.url.indexOf("/iam/users/me") >= 0 ||
      req.url.indexOf("/notification") >= 0 ||
      req.url.indexOf("/recoveries") >= 0 ||
      req.url.indexOf("/healthcare/vaccines/") >= 0 ||
      req.url.indexOf("/billing/customers/") >= 0 ||
      req.url.indexOf("/calendar/shifts") >= 0 ||
      req.url.indexOf("/organization/tenants") >= 0 ||
      req.url.indexOf("/api/tenants") >= 0
    ) {
      if (req.body) {
        clonedRequest = req.clone({
          body: swapProperty("id", "_id", req.body)
        });
      }

      return next.handle(clonedRequest ?? req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body) {
            return <HttpEvent<any>>event.clone({
              body: swapDeepProperty("_id", "id", event.body)
            });
          }

          return event;
        })
      );
    } else {
      if (req.body) {
        clonedRequest = req.clone({
          body: swapDeepProperty("id", "_id", req.body)
        });
      }

      return next.handle(clonedRequest ?? req).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.body) {
            return <HttpEvent<any>>event.clone({
              body: swapDeepProperty("_id", "id", event.body)
            });
          }

          return event;
        })
      );
    }
  }
}
